module.exports = "/_next/static/images/BusinessPlan-sm-8187c914524786b08117a80947125cd9.png";